import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getLocalParticipant } from '../../base/participants/functions';
import { OverlayChat } from './OverlayChat';
// Enum pour les types de messages (doit être identique à celui de OverlayChat)
var ChatMessageType;
(function (ChatMessageType) {
    ChatMessageType["AUTH_TOKEN"] = "AUTH_TOKEN";
    ChatMessageType["TOGGLE_CHAT_OVERLAY"] = "TOGGLE_CHAT_OVERLAY";
})(ChatMessageType || (ChatMessageType = {}));
const OverlayChatContainer = () => {
    const [isChatOpen, setIsChatOpen] = useState(false);
    const localParticipant = useSelector((state) => getLocalParticipant(state));
    // Récupérer le nom d'utilisateur depuis VisioGate en priorité
    const getUserName = () => {
        const visioName = sessionStorage.getItem('VISIO_USER_NAME');
        if (visioName) {
            return visioName;
        }
        if (localParticipant && localParticipant?.name) {
            return localParticipant.name;
        }
        return 'Utilisateur';
    };
    const userName = getUserName();
    // Récupérer le nom de la salle depuis l'URL
    const roomId = window.location.pathname.replace('/', '') || '';
    // Écouter les événements clavier et les messages postMessage
    useEffect(() => {
        const handleKeyPress = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'm') {
                e.preventDefault();
                setIsChatOpen(prev => !prev);
            }
            if (e.key === 'Escape' && isChatOpen) {
                setIsChatOpen(false);
            }
        };
        // Écouter les messages pour ouvrir/fermer le chat (depuis le bouton toolbar)
        const handleMessage = (event) => {
            if (event.data?.type === ChatMessageType.TOGGLE_CHAT_OVERLAY) {
                setIsChatOpen(prev => !prev);
            }
        };
        const handleCustomEvent = () => {
            setIsChatOpen(prev => !prev);
        };
        window.addEventListener('keydown', handleKeyPress);
        window.addEventListener('message', handleMessage);
        window.addEventListener(ChatMessageType.TOGGLE_CHAT_OVERLAY, handleCustomEvent);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
            window.removeEventListener('message', handleMessage);
            window.removeEventListener(ChatMessageType.TOGGLE_CHAT_OVERLAY, handleCustomEvent);
        };
    }, []);
    return (React.createElement(OverlayChat, { isOpen: isChatOpen, onToggle: () => setIsChatOpen(!isChatOpen), userName: userName, roomId: roomId }));
};
export default OverlayChatContainer;
